import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

import type { ComponentProps } from '~/chords/ComponentProps';
import { getClassNameOverride } from '~/chords/getClassNameOverride';
import { cn } from '~/lib/cn';

interface ModalDialogFooterProps
  extends Omit<ComponentProps<HTMLAttributes<HTMLDivElement>>, 'className'> {
  children: ReactNode;
  showCloseButton?: boolean;
}

export const ModalDialogFooter = forwardRef<
  HTMLDivElement,
  ModalDialogFooterProps
>(({ children, ...props }, ref) => {
  const className = getClassNameOverride(props, 'ModalDialog.Footer');

  return (
    <div
      ref={ref}
      {...props}
      className={cn(
        'flex justify-end gap-lg border-t-px px-xl py-md bg-level-03 border-t-emphasis-subtle',
        className,
      )}
    >
      {children}
    </div>
  );
});

ModalDialogFooter.displayName = 'ModalDialog.Footer';
